import { IconWrapper } from '../runtime';
export default IconWrapper('web-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + '597ec7e3' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12 4.59375C7.60629 4.59375 3.84375 7.80477 3.84375 12C3.84375 16.1952 7.60629 19.4062 12 19.4062C16.3937 19.4062 20.1562 16.1952 20.1562 12C20.1562 7.80477 16.3937 4.59375 12 4.59375ZM11.521 6.67222C11.6787 6.66165 11.8384 6.65625 12 6.65625C12.1749 6.65625 12.3476 6.66257 12.5179 6.67494C12.5797 6.84179 12.6467 7.00995 12.7161 7.18434C13.069 8.06992 13.4859 9.11632 13.6007 10.9688H10.4385C10.5571 9.14896 10.9798 8.06704 11.3326 7.16431C11.3987 6.99522 11.4623 6.83241 11.521 6.67222ZM8.37326 10.9688C8.4676 9.35949 8.77331 8.18727 9.07445 7.30865C7.4975 8.06872 6.37269 9.41984 6.02195 10.9688H8.37326ZM6.02195 13.0312H8.37326C8.4676 14.6405 8.77331 15.8127 9.07446 16.6914C7.4975 15.9313 6.37269 14.5802 6.02195 13.0312ZM10.4385 13.0312H13.6007C13.4859 14.8837 13.069 15.9301 12.7162 16.8157C12.6467 16.99 12.5797 17.1582 12.5179 17.3251C12.3476 17.3374 12.1749 17.3438 12 17.3438C11.8384 17.3438 11.6787 17.3384 11.521 17.3278C11.4623 17.1676 11.3987 17.0048 11.3326 16.8357C10.9798 15.933 10.5571 14.851 10.4385 13.0312ZM15.6656 13.0312C15.5746 14.6482 15.2779 15.8025 14.9816 16.664C16.5291 15.8991 17.6315 14.5618 17.9781 13.0312H15.6656ZM17.9781 10.9688C17.6315 9.43824 16.5291 8.10085 14.9816 7.33599C15.2779 8.19746 15.5746 9.35181 15.6656 10.9688H17.9781Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '597ec7e3',
      "x1": "0",
      "y1": "-9.15527e-05",
      "x2": "24",
      "y2": "23.9999",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#8497B8"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#60718D"
    }
  })])])]);
});